<template>
  <div>

    <div @click="back()" style="height: 30px;width: 60px;display: flex;align-items: center;cursor: pointer;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
          d="M10.9825 3.58692L10.2867 2.89111L3.85938 9.3198L10.2867 15.7478L10.9825 15.052L5.24986 9.31938L10.9825 3.58692Z"
          fill="#595959" />
      </svg>
      <span style="margin-left: 1px;margin-top: -2px;color: #595959;">返回</span>
    </div>

    <div style="height: 100%;width: 100%;">

      <div class="content-head">
        <div class="head-title">业绩预告</div>
        <div class="head-search" style="width: 80%;">
          <!-- <el-input v-model="searchText" placeholder="证券简称或代码"></el-input> -->

          <div style="width: 70px;text-align: right;">报告期：</div>
          <el-select v-model="stageTemp" @change="changeDate" placeholder="请选择">
            <el-option v-for="(item, index) in stageList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>

          <div style="width: 7px;"></div>

          <div style="width: 55px;text-align: right;">类型：</div>
          <el-select v-model="classTemp" multiple collapse-tags placeholder="类型筛选">
            <el-option v-for="(item, index) in classList" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>

          <div style="width: 7px;"></div>

          <div style="width: 70px;text-align: right;">交易所：</div>
          <el-select v-model="queryParam.node" placeholder="请选择">
            <el-option v-for="(item, index) in exchangeList" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>

          <div style="width: 7px;"></div>

          <el-button @click="getData">搜索</el-button>
        </div>
      </div>

      <div class="table-box">
        <table cellspacing="0">
          <thead>
            <tr>
              <th>股票代码</th>
              <th>股票名称</th>
              <th>类型</th>
              <th>归母净利润同比</th>
              <th>公告日期</th>
              <th>详情</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="tableData == null || tableData == undefined || tableData.length == 0">
              <tr>
                <td colspan="99">暂无数据</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(item, index) in tableData" :key="index">
                <td>{{ item.comCode }}</td>
                <td>{{ item.sname }}</td>
                <td>{{ classList[parseInt(item.type_id) - 1].name }}</td>
                <td>
                  <div>{{ toMoney(item.jlr_min) + '~' + toMoney(item.jlr_max) }}</div>
                  <div>{{ toRate(item.jlr_inc_min) + '~' + toRate(item.jlr_inc_max) }}</div>
                </td>
                <td>{{ toDate(item.publish_date) }}</td>
                <td>
                  <div class="text-button-enable" @click="viewCompany(item)">分析</div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div class="paging">
        <!-- <div class="pading-total"> -->
        <!-- 共&nbsp;{{ pages }}&nbsp;页&nbsp;&nbsp;&nbsp;&nbsp;当前&nbsp;{{ queryParam.pageNum }}&nbsp;页 -->
        <!-- 共&nbsp;{{ total }}&nbsp;条 -->
        <!-- </div> -->
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 15, 20, 30, 40, 50]"
          :current-page="queryParam.page" :page-size="queryParam.num" :total="total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" class="paging-pages">
        </el-pagination>
      </div>

    </div>

    <div style="color:#9a9a9a; padding: 5px;margin-top: 30px;">
      免责声明：上述所有信息均基于市场公开数据，经数据自动处理技术和人工智能算法产生，碧湾将尽力但不能保证其绝对准确和可靠，且亦不会承担因任何不准确或遗漏而引起的任何损失或损害的责任。所有数据信息仅供参考，不构成任何投资建议，不代表碧湾观点，投资者据此操作，风险自担。
    </div>

  </div>
</template>
    
<script>
import { linkName, sendRequestIndustry } from '../../../../static/js/util';

export default {
  data() {
    return {
      searchText: '',
      queryParam: {
        page: 1,
        num: 10,
        node: 'all',
        year: '',
        typeId: 0,
        stage: ''
      },
      stageList: [
        { id: 0, name: '加载中', year: '', stage: '' },
      ],
      stageTemp: 0,
      classList: [
        { name: '出现亏损', value: 1 },
        { name: '扭亏为盈', value: 2 },
        { name: '盈利大幅增加', value: 3 },
        { name: '盈利大幅减少', value: 4 },
        { name: '盈利小幅增加', value: 5 },
        { name: '继续盈利(幅度不定)', value: 6 },
        { name: '亏损大幅减少', value: 7 },
        { name: '亏损大幅增加', value: 8 },
        { name: '亏损小幅增加', value: 9 },
        { name: '继续亏损(幅度不定)', value: 10 },
        { name: '盈利小幅减少', value: 11 },
        { name: '亏损小幅减少', value: 12 },
      ],
      classTemp: [],
      exchangeList: [
        { name: '全A', value: 'all' },
        { name: '上交所', value: 'sh' },
        { name: '深交所', value: 'sz' },
      ],
      total: 1,
      pages: 1,
      tableData: []
    };
  },
  mounted() {
    this.getReportDate();
  },
  methods: {
    back() {
      linkName(this, 'market');
    },
    //报告期
    changeDate(newId) {
      var temp = this.stageList[newId];
      this.queryParam.year = temp.year;
      this.queryParam.stage = temp.stage;
    },
    toDate(date) {
      return date.substring(0, 4) + '-'
        + date.substring(4, 6) + '-'
        + date.substring(6, 8)
    },
    toRate(num) {
      num = parseFloat(num)
      if (isNaN(num)) {
        return '-';
      } else {
        return num.toFixed(2) + '%';
      }
    },
    //金额单位转万元
    toMoney(num) {
      if(num==''){
        return '-';
      }
      if (num == null || num.length == 0) {
        return 0;
      }
      var minus = 1;
      if (num < 0) {
        minus = -1;
        num = num * -1;
      }
      if (num < 10000) {
        num = parseFloat(num);
        return minus * num.toFixed(2) + '';
      } else if (num < 100000000) {
        var temp = num / 10000;
        return minus * temp.toFixed(2) + ' 万';
      } else {
        var temp = num / 100000000;
        return minus * temp.toFixed(2) + ' 亿';
      }
    },
    getReportDate() {
      sendRequestIndustry('/sina/foreshowDate',
        'get',
        null,
        res => {
          if (res.data.code == 0) {
            this.queryParam.year = res.data.data.year;
            this.queryParam.stage = res.data.data.stage;
            var yearList = res.data.data.yearList;
            for (var i = 0; i < yearList.length; i++) {
              yearList[i].id = i;
              yearList[i].name = yearList[i].year + '年' + yearList[i].stage;
            }
            this.stageList = yearList;
            this.getData();
          } else {
            // this.$message.error(res.data.msg);
            if (res.data.msg == '5002') {
              this.$alert('您的查看次数已用完，成为VIP即享碧湾所有分析数据', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  window.history.back();
                }
              });
            } else {
              console.log(res.data);
              this.$message.error(res.data.msg);
            }
          }
        }, err => {
          console.log(err);
        })
    },
    //获取数据
    getData() {
      // const loading = this.$loading({
      //     target: $('.table-box')[0],
      //     lock: true,
      //     text: '加载中',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(255, 255, 255, 0.8)'
      // });
      var type = this.classTemp.toString();
      if (type == null || type.length == 0) {
        type = '0';
      }
      this.queryParam.typeId = type;
      sendRequestIndustry('/sina/foreshow' +
        '?page=' + this.queryParam.page +
        '&num=' + this.queryParam.num +
        '&node=' + this.queryParam.node +
        '&year=' + this.queryParam.year +
        '&typeId=' + this.queryParam.typeId +
        '&stage=' + this.queryParam.stage,
        'get',
        null,
        res => {
          // loading.close();
          // console.log(res)
          if (res.data.code == 0) {
            this.tableData = res.data.data.records;
            this.total = res.data.data.total;
            this.pages = res.data.data.pages;
          }
        }, err => {
          // loading.close();
          console.log(err);
        })
    },
    viewCompany(row) {
      window.top.location = '/beawanHome/companyResearch/research?comCode=' + row.comCode + '&name=' + row.sname;
    },
    //每页多少条
    handleSizeChange(num) {
      this.queryParam.num = num;
      this.getData();
    },
    //换页
    handleCurrentChange(index) {
      this.queryParam.page = index;
      this.getData();
    }
  }
};
</script>
    
<style scoped>
@import "../../../../static/css/marketItemView.css";
</style>